import { itemHealthByItemIdsResponseSchema } from '@tempo-io/reporting-store-dto';
import {
  INSIGHTS_TIMEOUT_MS,
  REPORTING_STORE_API_BASE,
} from '@/common/api/reporting-store/constants';
import { tempoApi } from '@/common/api/tempoApi';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import type { ItemHealthByItemIdsRequest } from '@/common/api/types/dashboard/health';
import { itemsHealthMetricsResponseSchema } from '@/common/api/types/dashboard/health';
import { buildInsightsApiFilter } from '@/features/insights-dashboard/utils/buildInsightsApiFilter';

const getHealthSummary = async ({
  filters,
  scopeItemId,
  loopId,
}: {
  filters: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
}) => {
  const filterString = buildInsightsApiFilter(filters, scopeItemId, loopId);

  const response = await tempoApi()
    .get(`${REPORTING_STORE_API_BASE}/health/summary`, {
      searchParams: {
        ...(filterString && { filter: filterString }),
      },
      timeout: INSIGHTS_TIMEOUT_MS,
    })
    .json();

  return itemsHealthMetricsResponseSchema.parse(response);
};

const getItemHealth = async (request: ItemHealthByItemIdsRequest) => {
  const response = await tempoApi()
    .post(`${REPORTING_STORE_API_BASE}/health/by-item-ids`, {
      json: request.itemIds,
      timeout: INSIGHTS_TIMEOUT_MS,
    })
    .json();

  return itemHealthByItemIdsResponseSchema.parse(response);
};

export const HealthApi = {
  getHealthSummary,
  getItemHealth,
};
